import { ref, computed } from 'vue'
import { useShopStore } from '@/stores/useShopStore'

export function useShopData() {
  const shopStore = useShopStore()
  const loading = ref(true)
  const error = computed(() => shopStore.error)
  const inactive = computed(() => shopStore.inactive)

  if (shopStore.articles.length > 0 && shopStore.bookings.length > 0) {
    loading.value = false
  }

  shopStore.load().then(() => {
    loading.value = false
  })

  return { loading, error, inactive }
}
